import React from "react";
import {VykazStreetwork} from "../../model/zapisy/vykaz-streetwork.entity";
import {OperationType} from "@michalrakus/x-react-web-lib/XUtils";
import {XAutoCompleteBase} from "@michalrakus/x-react-web-lib/XAutoCompleteBase";
import {VykazStreetworkBrowse} from "./VykazStreetworkBrowse";
import {VykazStreetworkHlavickaForm} from "./VykazStreetworkHlavickaForm";

export const VykazStreetworkAutoComplete = (props: {
    value: VykazStreetwork | null;
    onChange: (vykazStreetwork: VykazStreetwork | null, objectChange: OperationType) => void;
    error: string | undefined;
    onErrorChange: (error: string | undefined) => void;
    readOnly?: boolean;
    maxWidth?: string;
}) => {

    return (
        <div className="w-full m-1" style={{maxWidth: props.maxWidth}}>
            <XAutoCompleteBase value={props.value} onChange={props.onChange} error={props.error} onErrorChange={props.onErrorChange} idField="id"
                               field={["datum", "vykazXUserList.xUser.name"]}
                               suggestionsQuery={{entity: "VykazStreetwork", sortField: [{field: "datum", order: -1}, {field: "id", order: -1}]}}
                               searchBrowse={<VykazStreetworkBrowse/>} valueForm={<VykazStreetworkHlavickaForm/>}
                               insertButtonTooltip="Nový denník" updateButtonTooltip="Upraviť denník"
                               width="100%" scrollHeight="50rem" readOnly={props.readOnly}
                               suggestionsLoad="lazy" lazyLoadMaxRows={30} minLength={2}/>
        </div>
    );
}